<template>
  <BreadCrumb PageTitle="Countries" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <CountryContent />
    </div>
  </div>
</template>

<script setup>
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CountryContent from "../../components/Admin/Country/CountryContent.vue";

import { useAccountStore } from "@/stores";
import { storeToRefs } from "pinia";
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>

